import { AxiosError } from 'axios';

import type { TApiException } from '@shared/types';

export const toApiException = (error: unknown): TApiException | null => {
  if (error instanceof AxiosError && error.response?.data.type === 'api') {
    return error.response.data as TApiException;
  }
  return null;
};
